import { Record as record } from 'immutable';

import { construct, fields } from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    amount: null,
    transactionId: null,
    cardPan: null,
    cardType: null,
    created: null,
    refunded: false,
    latest: false
};

export default class BraintreeCardPayment extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(BraintreeCardPayment, json, {
            id: fields.number,
            amount: fields.number,
            transactionId: fields.string,
            cardPan: fields.string,
            cardType: fields.string,
            created: fields.datetime,
            refunded: fields.bool,
            latest: fields.bool,
        });
    }

    hasAmount () {
        return this.amount > 0;
    }

    isRefundable () {
        return this.hasAmount();
    }

}
